import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';

import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import store from './ducks/store';
import scroll from './Components/Tools/scroll';
import routes from './routes';

class App extends Component {
  state = {
    navClass: false,
    nav: false
  };

  componentDidMount() {
    scroll();
  }

  sideNav = e => {
    const id = e.target.id
    if (id === 'b1' || id === 'b2' || id === 'b3' || id === 'b4') {
      this.setState({ nav: true });
    } else if (e.target.id !== 'side-nav') {
      this.setState({ navClass: true }, () => {
        setTimeout( () => {
          this.setState({nav: false, navClass: false})          
        }, 700)
      })
  }
  };


  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App" onClick={this.sideNav}>
            <Header nav={this.state.nav} navClass={this.state.navClass} />
            {routes}
            <Footer />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js